import { Configuration, LogLevel } from '@azure/msal-browser';

const tenantDomain = import.meta.env.VITE_AZURE_ADB2C_TENANT_DOMAIN;
// const apiScope = `https://${tenantDomain}/api/admin.super`;
const apiScope = `https://${tenantDomain}/${import.meta.env.VITE_AZURE_ADB2C_RESOURCE_IDENTIFIER}/admin.super`;
const apiHeaders = { "Content-Type": "application/json" };

const b2cPolicies = {
    names: {
        signUpSignIn: import.meta.env.VITE_AZURE_ADB2C_POLICY_NAME as string,
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${import.meta.env.VITE_AZURE_ADB2C_AUTHORITY_DOMAIN as string}/${import.meta.env.VITE_AZURE_ADB2C_TENANT_DOMAIN as string}/${import.meta.env.VITE_AZURE_ADB2C_POLICY_NAME as string}/`,
        }
    },
    authorityDomain: import.meta.env.VITE_AZURE_ADB2C_AUTHORITY_DOMAIN as string,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_ADB2C_CLIENT_ID as string,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: '/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    },
    system: {
        loggerOptions: {
            /**
             * Below you can configure MSAL.js logs. For more information, visit:
             * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
             */
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                    case LogLevel.Info:
                    case LogLevel.Verbose:
                    case LogLevel.Warning:
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

const sharedScopes = { admin_super: [apiScope] };
const sharedHeaders = apiHeaders;

export const protectedResources = {
    ftpDownloadJobLogApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/logs/ftp-download-jobs/:id`,
        headers: sharedHeaders,
        scopes: sharedScopes,
    },
    systemNotificationsApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/logs/system/all`,
        headers: sharedHeaders,
        scopes: sharedScopes,
    },
    weatherApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/weather-forecast/base`,
        headers: sharedHeaders,
        scopes: sharedScopes,
    },
    companyMasterApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/company`,
        scopes: sharedScopes,
    },
    workerHealthApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/workers/health/current`,
        headers: sharedHeaders,
        scopes: sharedScopes,
    },
    regressionTestingApi: {
        endpoint: `${import.meta.env.VITE_WEBAPI_BASE_URL as string}/api/v1/regression-tests`,
        headers: sharedHeaders,
        scopes: sharedScopes,
    },
};

/**
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.weatherApi.scopes.admin_super],
};

export default msalConfig;